module.exports = __webpack_public_path__ + "static/media/2.c87587db.jpg";